
import Notifications from "@/Notifications/Notifications.vue";
import { defineComponent } from "vue";
import AppBar from "./AppBar.vue";
import MainView from "./MainView.vue";

export default defineComponent({
  components: {
    AppBar,
    MainView,
    Notifications,
  },
});
